import { urlAnalysis } from '../../../actions';
import createReducer from '../../../utils/createReducer';

export default createReducer(
  {},
  {
    [urlAnalysis.set.type]: (state, { payload }) => payload,
  },
);
